import { useEffect, useState } from "react";
import { getProducts } from "../../../api/apiServices";
import { mapProductToCard } from "../../../utils/mapProduct";
import ProductCard from "./ProductCard";
import CategorySection from "./CategorySection";


export default function ProductGrid() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const data = await getProducts();

        const formattedProducts = data.map(mapProductToCard);

        setProducts(formattedProducts);
      } catch (error) {
        console.error("Failed to load products:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

const filteredProducts = selectedCategory
  ? products.filter(p => p.category === selectedCategory)
  : products;

  if (loading)
    return <div className="text-center py-20">Loading products...</div>;

  return (
    <section className="py-12">
      <div className="text-center mb-10">
        <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-gray-800 mb-3">
          New Arrivals
        </h2>
        <p className="text-gray-500 font-['Poppins'] text-sm">
          Fresh styles just for you
        </p>
      </div>

      {products.length === 0 ? (
        <div className="text-center text-gray-500 py-16">
          No products available
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">

          {filteredProducts.map((product) => (
            <ProductCard key={product._id} {...product} />
          ))}
        </div>
      )}
    </section>
  );
}
